import { FC } from 'react';
// components
import SandCoating from 'components/main/SandCoating/Edit';

const EditSandCoating: FC = () => <SandCoating />;

export default EditSandCoating;
